import { StoreContext } from '../../../lib/store';
import * as React from 'react';
import { useContext } from 'react';
import { CountdownCloseButton } from 'common/components/close-button/countdown';
import { CloseButton } from 'common/components/close-button';
import { TIMERS } from 'common/stores/constants/timers.constant';
import { btnPaddingStyle } from 'common/js/configs/utils';
import style from './styles.scss';

export function Component() {
  const defaultPosition: number = 0;
  const store = useContext(StoreContext);
  const { mraidStore, uiTimerStore, formatConfig, creativeStore } = store;
  const { closeBtn, useBtnAutoMargin } = formatConfig;

  const closeButtonTimerExists = uiTimerStore.has(TIMERS.CLOSE_BUTTON_TIMER);

  const useCloseDownButton =
    closeBtn.legacyUseCountdownCloseButton || closeBtn.useCountdownCloseButton;
  const userCloseHandler = (e: any) => {
    store.userCloseHandler.handle(e);
  };

  let closeButtonTimer = closeBtn.displayAfter;
  let isCloseButtonVisible = false;

  if (closeButtonTimerExists) {
    closeButtonTimer =
      uiTimerStore.get(TIMERS.CLOSE_BUTTON_TIMER)!.elapsedTime / 1000;
    isCloseButtonVisible = uiTimerStore.get(TIMERS.CLOSE_BUTTON_TIMER)!
      .isFinished;
  }

  const shouldShowCountdownCloseButton =
    !isCloseButtonVisible && useCloseDownButton && closeButtonTimerExists;

  const creativeLeftShift =
    useBtnAutoMargin && creativeStore.creativeSize?.left != null
      ? creativeStore.creativeSize.left
      : 0;
  const closeBtnStyle: React.CSSProperties = {
    left:
      closeBtn?.position === 'left'
        ? defaultPosition + creativeLeftShift
        : 'auto',
    right:
      closeBtn?.position === 'right'
        ? defaultPosition + creativeLeftShift // use the same left position because your creative is aligned in the middle of the container
        : 'auto'
  };

  const closeControlBlockStyle: React.CSSProperties = btnPaddingStyle(
    4,
    closeBtn.largeClickableZonePadding,
    closeBtn.position
  );

  return (
    <>
      {mraidStore.canDisplayCloseButton && shouldShowCountdownCloseButton && (
        <div className={style.countDownCloseBtnPosition} style={closeBtnStyle}>
          <CountdownCloseButton
            {...closeBtn}
            elapsedTime={closeButtonTimer}
            iconSize={closeBtn.iconSize}
            iconPadding={closeBtn.paddingSize}
            controlBlockStyle={closeControlBlockStyle}
            isViewable={mraidStore.mraidViewability}
          />
        </div>
      )}
      {mraidStore.canDisplayCloseButton && isCloseButtonVisible && (
        <div className={style.closeBtnPosition} style={closeBtnStyle}>
          <CloseButton
            {...closeBtn}
            iconSize={closeBtn.iconSize}
            iconPadding={closeBtn.paddingSize}
            onClick={userCloseHandler}
            controlBlockStyle={closeControlBlockStyle}
            hideOnClick={true}
          />
        </div>
      )}
    </>
  );
}
